namespace('compass.group');
compass.require('compass.hotel.StayVisualizationWidget');
compass.require('compass.hotel.RoomRequestsWidget');
compass.require('compass.demographic.PaymentWidget');
compass.require('compass.demographic.CreditCardWidget');
compass.require('compass.hotel.SharesWidget');
compass.require('compass.demographic.FrequentGuestNumberWidget');

compass.require('compass.util.validate');
compass.require('compass.util.parse');

compass.group.ModifyRoomWidget= compass.defineWidget(function ModifyRoomWidget(options) {
	var me = this;
	var $j = jQuery;
	var d = jQuery.dom;

	var _settings = options;
	var _labels = _settings.labels;
	var _roommatesFormInvalid = false;
	var roommatesForm;
	var _paymentFormInvalid = false;
	var _paymentWidget;

	var _validateRoommates = function(){
		if($(this).hasClass("disabled")) {
			return;
		}

		//disable button to prevent multiple triggers of the event
		$(this).addClass("disabled");

		var form = me.find('.roommatesForm');

		form.parsley().validate();

 		if(!form.parsley().isValid()){
			_roommatesFormInvalid = true;
 			return;
 		}
	};

	var renderRoommates = function() {
		var roommatesForm = d.form({className: 'roommatesForm'});
		var _sharesWidget = new compass.hotel.SharesWidget(roommatesForm, {
				numberOfShares: _settings.reservationInfo.roomTypeBase.occupancy - 1,
				readOnly: false,
				inlineLabels: true,
				roomMatesLabel: true,
				shares: _settings.reservationInfo.roommates,
				translate : true
			});

		var roommatesSubmitButton = d.button({
			className: 'roommatesSubmitButton button',
			'tabIndex': '0'
		}, _labels.roommatesSubmit);

		roommatesSubmitButton.activate(function() {
			if(roommatesSubmitButton.hasClass("disabled")) { return; }
			_validateRoommates();
		});
		roommatesSubmitButton.addClass('disabled');
		roommatesForm.append(roommatesSubmitButton);

		_sharesWidget.bind('SharesWidget.fieldChanged', function (event) {
			roommatesSubmitButton.removeClass('disabled');
		});

		roommatesForm.submit(function() {
			if(_roommatesFormInvalid) { return; }
			var filteredShares = _.filter(_sharesWidget.grabValues(), function(roommate) {
				return (roommate.first_name.length !== 0 && roommate.last_name.length !== 0);
			});

			if(!roommatesSubmitButton.hasClass('disabled')) {
				roommatesSubmitButton.addClass('disabled');
				compass.loading.start(roommatesSubmitButton.empty());
				var eventData = {
					hotel_id: _settings.hotelData.hotelBase.hotel_id,
					block_id: _settings.block_id,
					housing_id: _settings.reservationInfo.reservationBase.housing_id,
					sharesData: {
						housing_id: _settings.reservationInfo.reservationBase.housing_id,
						shares: filteredShares
					},
					callback: function() {
						_settings.submitCallback();
					}
				};
				jQuery('body').trigger('ModifyGroupWidget.submitShares', eventData);
			}
			return false;
		});

		roommatesForm.parsley({
			aria: true,
			errorClass: 'invalid',
			excluded: 'input[type=password]',
			errorsContainer: function (elem) {
				elem = elem.$element;
				var $container = elem.next();

				if ($container.hasClass('reqHint')) {
					return $container;
				}

				var $container = d.div({ className: 'reqHint' });
				$container.append(d.div({ className: 'triangle' }));

				elem.after($container);
				
				elem.one('focus', function (evt) {
					$container.css({ "left": (elem.outerWidth(true)-$container.outerWidth(true))/2 + elem.position().left });
				});
				
				return $container;
			},
			errorsWrapper: '<div class=\'text\'></div>',
			errorTemplate: '<span></span>'
		});

		roommatesForm.parsley().on('form:error', function() {
 			_roommatesFormInvalid = true;
 			return;
 		});

		roommatesForm.parsley().on('field:validate', function(elem) {
			return !$(elem).is(":visible") || $(elem).hasClass('placeholder');
		});

		roommatesForm.parsley().on('field:success', function(elem) {
			if (_roommatesFormInvalid) { 
				if (me.find('.roommatesForm').find('.invalid').length < 1) {
					_roommatesFormInvalid = false;
					var button = me.find('.roommatesSubmitButton');
					button.removeClass('disabled').attr('tabindex', '0');
				}
			}
		});

		return roommatesForm;
	};

	var _triggerSubmitPayment = function(){
		var eventData = {
			hotel_id: _settings.hotelData.hotelBase.hotel_id,
			block_id: _settings.block_id,
			housing_id: _settings.reservationInfo.reservationBase.housing_id,
			paymentData: {
				housing_id: _settings.reservationInfo.reservationBase.housing_id,
				payment: _paymentWidget.grabValues()
			},
			callback: function() {
				_settings.submitCallback();
			}
		};
		jQuery('body').trigger('ModifyGroupWidget.submitPayment', eventData);
	};

	var _processPaymentSaveButtonClick = function(e){
		_addParsleyToCreditCardForm();

		if($(this).hasClass("disabled")) {
			return;
		}

		//disable button to prevent multiple triggers of the event
		$(this).addClass("disabled");

		var form = me.find('.paymentForm');

		form.parsley().validate();

 		if(!form.parsley().isValid()){
			_paymentFormInvalid = true;
 			return;
 		}
 		compass.loading.start($(this).empty());
 		_triggerSubmitPayment();

 		return false;
	};



	var renderPayment = function() {
		var paymentForm = d.form({className: 'paymentForm'});

		last_processed_date = compass.util.parse.ISODateParser(_settings.payment.last_processed_date);
		_format = compass.util.dateFormatter('medium');

		if (_settings.payment.obligation_status === 'FAILED') {
			paymentForm.append(d.div({ className: 'failedPayment'}, _settings.payment.nameOnCard + "'s " + _settings.payment.type + " ending in " + _settings.payment.lastFour + " was unable to be processed on " + _format(last_processed_date) + '.'));
		}

		_paymentWidget = new compass.demographic.PaymentWidget(paymentForm, {
			WUID : 'paymentWidget_modifyRoomWidget',
			addressWidget : {
				countries : _settings.countriesAndStates.countries,
				states : _settings.countriesAndStates.states,
				countriesWithStates : _settings.countriesAndStates.countriesWithStates
			},
			creditCardTypes : _settings.hotelData.payMethods,
			minExpiration: compass.util.parse.ISODateParser(_settings.reservationInfo.reservationBase.depart),
			displayCVC: _settings.meetingInfo.storeCvc,
			storedPayments: _settings.reservationInfo.payments,
			currentPayment: _settings.reservationInfo.currentPayment,
			maskCCNumber : _.contains(_settings.extraRequiredFields, 'maskCreditCard'),
			translate : true,
			cardWillBeCharged: _settings.blockChargeInfo.has_charging ? _settings.blockChargeInfo.has_charging : false,
			cardHasBeenCharged: _settings.memberChargeInfo.has_been_charged ? _settings.memberChargeInfo.has_been_charged : false,
			cardHasDeposit: _settings.memberChargeInfo.has_been_charged ? _settings.memberChargeInfo.has_deposit : false,
			cardHasServiceFees: _settings.memberChargeInfo.has_service_fees ? _settings.memberChargeInfo.has_service_fees : false,
			displayBillingNotes: _settings.payment.displayBillingNotes ? _settings.payment.displayBillingNotes : false,
			billingNotes: _settings.payment.billingNotes,
			displayEarnedComps: _settings.payment.displayEarnedComps ? _settings.payment.displayEarnedComps : false,
			availableEarnedComps: _settings.payment.availableEarnedComps,
			arriveDate: _settings.reservationInfo.reservationBase.arrive,
			departDate: _settings.reservationInfo.reservationBase.depart,
			earnedCompsUsed: _settings.payment.earnedCompsUsed,
			payMethods: _settings.payment.options
		});

		var paymentSubmitButton = d.button({
				className: 'paymentSubmitButton button',
				'tabIndex': '0'
		}, _labels.paymentSubmit);

		paymentSubmitButton.activate(_processPaymentSaveButtonClick);

		// the submit button does not need to be disabled when a new credit card is the only payment option (eg: company guarantee)
		if(me.find('.paymentSelect').length > 0) {
			paymentSubmitButton.addClass('disabled');
		}
		
		// Don't render the payment button if the user has been charged and there are deposits associated with them
		if (_settings.memberChargeInfo.has_been_charged === false || _settings.memberChargeInfo.has_deposit === false) {
			paymentForm.append(paymentSubmitButton);
		}

		_paymentWidget.bind('PaymentWidget.change', function (event,eventData) {
			paymentSubmitButton.removeClass('disabled');
			if(eventData === "__NEW__") {
				compass.GA.trackEvent('Modify Member', 'Update', 'Add New Payment');
			}
		});

		_paymentWidget.bind('PaymentWidget.earnedCompsChange', function(event) {
			paymentSubmitButton.removeClass('disabled');
		});

		paymentForm.parsley({
			aria: true,
			errorClass: 'invalid',
			excluded: 'input[type=password]',
			errorsContainer: function (elem) {
				elem = elem.$element;
				var $container = elem.next();

				if ($container.hasClass('reqHint')) {
					return $container;
				}

				var $container = d.div({ className: 'reqHint' });
				$container.append(d.div({ className: 'triangle' }));

				elem.after($container);
				
				elem.one('focus', function (evt) {
					$container.css({ "left": (elem.outerWidth(true)-$container.outerWidth(true))/2 + elem.position().left });
				});
				
				return $container;
			},
			errorsWrapper: '<div class=\'text\'></div>',
			errorTemplate: '<span></span>'
		});

		paymentForm.parsley().on('field:validate', function(elem) {
			return !$(elem).is(":visible") || $(elem).hasClass('placeholder');
		});

		paymentForm.parsley().on('field:success', function(elem) {
			if (_paymentFormInvalid) { _enableOrDisableSubmitButton(); }
		});
		
		return paymentForm;
	};

	var _addParsleyToCreditCardForm = function() {
		// credit card portion is variable and thus not parsleyized when this widget is initialized
		var _isCreditCard = me.find('.creditCard').length > 0;
		var _form = me.find('.paymentForm');

		if (_isCreditCard) {
			_form.parsley('addItem', '.cardNumberInput');
			_form.parsley('addItem', '.expMonth');
			_form.parsley('addItem', '.expYear');
			_form.parsley('addItem', '.input.nameOnCard');
			_form.parsley('addItem', '.address1Input');
			_form.parsley('addItem', '.cityInput');
			_form.parsley('addItem', '.stateSelect');
			_form.parsley('addItem', '.postalCodeInput');
		}
	};

	var _enableOrDisableSubmitButton = function() {
		if (me.find('.paymentForm').find('.invalid').length < 1) {
			_paymentFormInvalid = false;
			var button = me.find('.paymentSubmitButton');
			button.removeClass('disabled').attr('tabindex', '0');
		}
	};

	var renderRequests = function() {
		var requestsForm = d.form({className: 'requestsForm'});
		var _frequentGuestNumberWidget = new compass.demographic.FrequentGuestNumberWidget(requestsForm, {
			WUID : 'frequentGuestNumberWidget_modifyRoomWidget',
			frequentGuestNumber: _settings.reservationInfo.frequentGuestNumber
		});
		var _roomRequestsWidget = new compass.hotel.RoomRequestsWidget(requestsForm, {
			WUID : 'roomRequestsWidget_modifyRoomWidget',
			collapsable : true,
			roomRequestOptions : _settings.requestsInfo.requests,
			accessibilityOptions : _settings.requestsInfo.accessibility,
			showExtraNotes : _settings.requestsInfo.showExtraNotes,
			showADAOptions : _settings.requestsInfo.showADAOptions,
			notes : _settings.requestsInfo.notes
		});

		var requestsSubmitButton = d.button({
			className: 'requestsSubmitButton button',
			'tabIndex': '0'
		}, _labels.requestsSubmit);

		requestsSubmitButton.activate(function() {
			requestsForm.submit();
		});
		requestsSubmitButton.addClass('disabled');
		requestsForm.append(requestsSubmitButton);

		_frequentGuestNumberWidget.bind("FrequentGuestNumberWidget.guestNumberChanged", function (event) {
			requestsSubmitButton.removeClass('disabled');
		});

		requestsForm.parsley({
			aria: true,
			errorClass: 'invalid',
			excluded: 'input[type=password]',
			errorsContainer: function (elem) {
				elem = elem.$element;
				var $container = elem.next();

				if ($container.hasClass('reqHint')) {
					return $container;
				}

				var $container = d.div({ className: 'reqHint' });
				$container.append(d.div({ className: 'triangle' }));

				elem.after($container);
				
				elem.one('focus', function (evt) {
					$container.css({ "left": (elem.outerWidth(true)-$container.outerWidth(true))/2 + elem.position().left });
				});
				
				return $container;
			},
			errorsWrapper: '<div class=\'text\'></div>',
			errorTemplate: '<span></span>'
		});

		requestsForm.parsley().on('field:validate', function(elem){
			return !$(elem).is(":visible") || $(elem).hasClass('placeholder');
		});

		_roomRequestsWidget.bind("RoomRequestsWidget.roomNoteChanged", function (event) {
			requestsSubmitButton.removeClass('disabled');
		});

		_roomRequestsWidget.bind("roomRequestInputChanged", function (event) {
			requestsSubmitButton.removeClass('disabled');
		});

		requestsForm.submit(function() {
			if(!requestsSubmitButton.hasClass('disabled')) {
				requestsSubmitButton.addClass('disabled');
				compass.loading.start(requestsSubmitButton.empty());
				var requestsWidgetData = _roomRequestsWidget.grabValues();
				var requestsData = {
					housing_id: _settings.reservationInfo.reservationBase.housing_id,
					requests: requestsWidgetData.requests,
					notes: requestsWidgetData.notes,
					frequentGuestNumber: _frequentGuestNumberWidget.grabValues()
				};
				var eventData = {
					hotel_id: _settings.hotelData.hotelBase.hotel_id,
					block_id: _settings.block_id,
					housing_id: _settings.reservationInfo.reservationBase.housing_id,
					requests: requestsData,
					callback: function() {
						_settings.submitCallback();
					}
				};
				jQuery('body').trigger('ModifyGroupWidget.submitRequests', eventData);
			}
			return false;
		});

		return requestsForm;
	};

	var renderCancel = function() {
		var cancelHolder = d.div({className: 'cancelHolder'});
		var cancelValidator = new compass.validator({
			onValid : function (e) { e.removeClass('invalid'); },
			onInvalid: function (e) { e.addClass('invalid'); }
		});
		var _cancelWidget = new compass.hotel.CancelRoomWidget(cancelHolder, {
			currencyFormatter : _settings.meetingInfo.defaultCurrencyFormatter,
			validator: cancelValidator,
			cancelFee: _settings.cancelInfo.cancelFee,
			cancelReasons : _settings.cancelInfo.cancelReasons
		});
		
		var cancelButton = _cancelWidget.getCancelButton();
		var checkbox = _cancelWidget.getCheckbox();
		cancelButton.addClass('disabled');
		checkbox.addClass('disabled');

		_cancelWidget.bind('CancelRoomWidget.cancelFeeCheckboxChanged', function(event) {
			if (checkbox.length > 0 && checkbox.is(":checked")) {
				checkbox.removeClass('invalid');
				cancelButton.removeClass('disabled');
			} else if (checkbox.length > 0) {
				checkbox.addClass("invalid");
				cancelButton.addClass('disabled');
			} else {
				return;
			}
		});

		_cancelWidget.bind('CancelRoomWidget.Cancel', function(event, cancelData) {
			if(!cancelButton.hasClass('disabled')) {
				var fields = cancelValidator.validate();
				if (fields.length > 0) {
					return;
				}
				cancelButton.addClass('disabled');
				compass.loading.start(cancelButton.empty());
				var eventData = {
					hotel_id: _settings.hotelData.hotelBase.hotel_id,
					block_id: _settings.block_id,
					housing_id: _settings.reservationInfo.reservationBase.housing_id,
					cancelData: cancelData,
					callback: function() {
						_settings.submitCallback();
					}
				};
				jQuery('body').trigger('ModifyGroupWidget.cancelRoom', eventData);
			} else {
				return false;
			}
		});

		_cancelWidget.bind('CancelRoomWidget.cancelReasonsChanged', function(event) {
			cancelButton.removeClass('disabled');
		});

		return cancelHolder;
	};

	var renderPreventCancel = function() {
		var updatePayment = d.div({className: 'updatePayment'}, "Please update your payment information before you can cancel this room.");
		return updatePayment;
	};

	var modifyOptions = [];
	var roommatesOption = {label: _labels.roommatesOption,	className: 'roommatesOption', render: renderRoommates};
	var paymentOption = {label: _labels.paymentOption,	className: 'paymentOption', render: renderPayment};
	var requestsOption = {label: _labels.requestsOption, className: 'requestsOption', render: renderRequests};
	var cancelOption = {label: _labels.cancelOption, className: 'cancelOption', render: renderCancel};
	var preventCancelOption = {label: _labels.cancelOption, className: 'cancelOption', render: renderPreventCancel};

	if(_settings.reservationInfo.roomTypeBase.occupancy > 1) {
		modifyOptions.push(roommatesOption);
	}

	//Checks if the current paymethod is in the list of possible paymethods
		if( _.find(_settings.payment.options, function(payMethod) {
			return payMethod.code === _settings.reservationInfo.currentPayment.payMethodBase.code;
		}) || _settings.reservationInfo.currentPayment.payMethodBase.code === 'GUARANTEE') {
		modifyOptions.push(paymentOption);
	}

	modifyOptions.push(requestsOption);

	var preventCancel = (_settings.payment.obligation_status === 'FAILED' && _settings.cancelInfo.cancelFee > 0);

	if (_settings.canCancelBlock && _settings.reservationInfo.reservationBase.canCancel && preventCancel === false) {
		modifyOptions.push(cancelOption);
	} else if (preventCancel) {
		modifyOptions.push(preventCancelOption);
	}

	var _render = function (widgetElem) {
		var modifyOptionsHolder;
		var modifyOptionButtonsHolder;

		var stayVisualizationHolder = d.div({className: 'stayVisualizationHolder'});
		var stayVisualizationWidget = new compass.hotel.StayVisualizationWidget(stayVisualizationHolder, {
			nights : _.filter(_settings.reservationInfo.reservationBase.nights, function(n) {
				return n.date >= _settings.stay.arrive && n.date <= _settings.stay.depart;
			}),
			roomType: {roomTypeName: _settings.reservationInfo.reservationBase.roomTypeBase.name},
			currencyCode: _settings.meetingInfo.currencyCode,
			meetingInfo: {defaultCurrencyFormatter: _settings.meetingInfo.defaultCurrencyFormatter},
			translate : false
		});
		
		var modifyOptionsContent = _.map(modifyOptions, function(option) {
			var activeState = option.className === _settings.initialOptionClass ? ' activeOption' : '';
			return d.div({className: 'modifyOption ' + option.className + activeState}, option.render());
		});
		modifyOptionsHolder = d.div({className: 'modifyOptionsContent'}, modifyOptionsContent);

		var modifyOptionButtons = _.map(modifyOptions, function(option) {
			var changeModifyOption = function() {
				var activeOption = modifyOptionsHolder.find('.activeOption');
				if(!activeOption.hasClass(option.className)) {
					activeOption.removeClass('activeOption');
					modifyOptionButtonsHolder.find('.activeButton').removeClass('activeButton');

					modifyOptionsHolder.find('.' + option.className).addClass('activeOption');
					modifyOptionButtonsHolder.find('.' + option.className).addClass('activeButton');
				}
			};
			var activeState = option.className === _settings.initialOptionClass ? ' activeButton' : '';
			return d.div({className: 'modifyOptionButton ' + option.className + activeState}, option.label).activate(function() {
				
				if(option.className == 'roommatesOption') {
					var gaText = 'Roommates';
				} else if(option.className == 'paymentOption') {
					var gaText = 'Payment';
				} else if(option.className == 'requestsOption') {
					var gaText = 'Requests';
				} else if(option.className == 'cancelOption') {
					var gaText = 'Cancel';
				}

				compass.GA.trackEvent('Modify Member', 'View', gaText);
				changeModifyOption();
			});
		});
		modifyOptionButtons.push(d.div({className: 'clear'}));
		modifyOptionButtonsHolder = d.div({className: 'modifyOptionButtons'}, modifyOptionButtons);

		widgetElem.append([
			d.h2({className: 'modifyRoomTitle'}, _labels.title),
			d.div({className: 'hotelName'}, _settings.reservationInfo.reservationBase.hotelBase.name),
			d.div({className: 'attendeeName'}, _settings.reservationInfo.individualBase.first_name + ' ' + _settings.reservationInfo.individualBase.last_name),
			stayVisualizationHolder,
			modifyOptionButtonsHolder,
			modifyOptionsHolder
		]);
	};
	me.render = _render;
}, {
	WUID: 'MODIFYROOMWIDGET',
	widgetName: 'ModifyRoomWidget',
	meetingInfo: {},
	reservationInfo: {},
	requestsInfo: {},
	cancelInfo: {},
	blockChargeInfo: {},
	memberChargeInfo: {},
	initialOptionClass: 'roommatesOption',
	submitCallback: function() {},
	roommatesSubmitCallback: function() {},
	paymentSubmitCallback: function() {},
	labels: {
		title: 'Modify Reservation',
		roommatesOption: 'Roommates',
		paymentOption: 'Payment',
		requestsOption: 'Hotel Requests',
		cancelOption: 'Cancel',
		roommate: 'Roommate',
		roommatesSubmit: 'Add Roommates',
		paymentSubmit: 'Apply Payment',
		requestsSubmit: 'Save Requests',
		cancelSubmit: 'Cancel Reservation'
	}
});
